const ruNumberFormat = new Intl.NumberFormat('ru-RU', {
  style: 'currency',
  currency: 'RUB',
  maximumFractionDigits: 0,
});

export const formatCurrency = (value: number) => {
  return ruNumberFormat.format(value);
};
